import React, { useState, useEffect, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import { createModal } from "react-modal-promise";
import { useAxiosWithAuthorization } from "../../../utils/api";
import useAppContext from "../../../utils/Reducers";
import locationImg from "../../../images/location_pin.png";

var map;
var marker;
var popup;

const LoadAreaInfoPop = ({ vndrCd, rvndrCd, loadAreaCd }) => {
  //상차지 검색 URL
  const SERARCH_LOADAREA_URL = "/company/searchLoadAreaInfo.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SERARCH_LOADAREA_URL,
    },
    { manual: true }
  );

  const initItem = {
    systemCd: "",
    vndrCd: "",
    vndrNm: "",
    rvndrCd: "",
    rvndrNm: "",
    loadAreaCd: "",
    loadAreaNm: "",
    addr: "",
    addrDesc: "",
    latt: "",
    lont: "",
    note: "",
  };
  const [fieldValues, setFieldValues] = useState(initItem);
  const [show, setShow] = useState(true);
  const {
    store: { userInfo },
  } = useAppContext();

  const { Tmapv2 } = window;

  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    const initMap = () => {
      map = new window.Tmapv2.Map("map_div", {
        center: new window.Tmapv2.LatLng(35.0838475629019, 128.989000847098), // 지도 초기 좌표
        // width: "100%",
        height: "300px",
        zoom: 17,
      });

      marker = new Tmapv2.Marker({
        position: new Tmapv2.LatLng(35.0838475629019, 128.989000847098),
        map: map,
      });
      var content =
        "<div style='font-size:14px'>" + "<span> YK스틸</span>" + "</div>"; // 라벨 내용 지정

      popup = new Tmapv2.InfoWindow({
        position: new Tmapv2.LatLng(35.0838475629019, 128.989000847098), //Popup 이 표출될 맵 좌표
        content: content, //Popup 크기는 스타일로 지정, Popup 표시될 text
        type: 2,
        map: map, // 지도 객체
      });
    };

    initMap();
    handleSearch();
  }, []);

  const handleSearch = async () => {
    const {
      data: { data },
    } = await fetchData({
      params: {
        schVndrCd: vndrCd,
        schRvndrCd: rvndrCd,
        schLoadAreaCd: loadAreaCd,
      },
    });

    //console.log(data);
    setFieldValues(data[0]);
    setMapCenter(data[0].latt, data[0].lont, data[0].loadAreaNm);
  };

  const setMapCenter = (lat, lon, label) => {
    var content =
      "<div style='font-size:14px'><span>" + label + "</span></div>"; // 라벨 내용 지정

    map.setCenter(new Tmapv2.LatLng(lat, lon));
    map.setZoom(17);
    marker.setPosition(new Tmapv2.LatLng(lat, lon));
    popup.setPosition(new Tmapv2.LatLng(lat, lon));
    popup.setContent(content);
  };

  const handleClose = (returnData) => {
    setShow(false);
  };

  const handleOk = (returnData) => {
    setShow(false);
  };

  return (
    <>
      <Modal show={show} onHide={() => handleClose(false)}>
        <Modal.Header closeButton>
          <Modal.Title>상차지 정보</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="searchdata">
            <table className="t_garo">
              <tr>
                <th style={{ textAlign: "center", padding: "0" }} colSpan={4}>
                  <img src={locationImg} style={{ verticalAlign: "middle" }} />
                  상세지도
                </th>
              </tr>
              <tr>
                <td style={{ padding: "0" }} colSpan={4}>
                  <div id="map_div" style={{ width: "100%" }}></div>
                </td>
              </tr>
              <tr>
                <th>공급업체명</th>
                <td style={{ width: "200px" }}>{fieldValues?.vndrNm}</td>
                <th>실공급업체명</th>
                <td style={{ width: "200px" }}>{fieldValues?.rvndrNm}</td>
              </tr>
              <tr>
                <th>상차지명</th>
                <td style={{ width: "200px" }}>{fieldValues?.loadAreaNm}</td>
                <th>주소1</th>
                <td style={{ width: "200px" }}>{fieldValues?.addr}</td>
              </tr>
              <tr>
                <th>주소2</th>
                <td style={{ width: "200px" }}>{fieldValues?.addrDesc}</td>
                <th></th>
                <td style={{ width: "200px" }}></td>
              </tr>
              <tr>
                <th>비고</th>
                <td style={{ width: "200px" }}>{fieldValues?.note}</td>
              </tr>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => handleOk(true)}>
            확인
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export const ModalLoadAreaInfoPop = createModal(LoadAreaInfoPop);

export default LoadAreaInfoPop;
